import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Info, X } from 'lucide-react';
import { API } from '../../App';
import { useHubT } from './hubStrings';

// Shown when a user follows an old notification / shared link that carries a
// `?report={id}` param and the post is no longer active. Reveals ONLY the
// availability state — never the content, author or moderation details.
export const RemovedPostNotice = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hubT = useHubT();
  const reportId = searchParams.get('report');
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!reportId) { setState(null); return; }
    axios.get(`${API}/community-reports/${encodeURIComponent(reportId)}/status`)
      .then(r => setState(r.data?.state || null))
      .catch(() => setState(null));
  }, [reportId]);

  if (!reportId || !state || state === 'active') return null;

  const msgKey = {
    removed: 'noticeRemoved',
    resolved: 'noticeResolved',
    expired: 'noticeExpired',
    deleted: 'noticeDeleted',
  }[state] || 'noticeDeleted';

  const dismiss = () => {
    const next = new URLSearchParams(searchParams);
    next.delete('report');
    setSearchParams(next, { replace: true });
  };

  return (
    <div
      className="bg-slate-100 border border-slate-300 rounded-xl px-4 py-3 mb-4 flex items-start gap-2 text-slate-700 text-sm"
      data-testid={`removed-post-notice-${state}`}
    >
      <Info className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="flex-1">
        {state === 'removed' && <p className="font-semibold">{hubT('noticeRemovedTitle')}</p>}
        <p>{hubT(msgKey)}</p>
      </div>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="removed-post-notice-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default RemovedPostNotice;
